import { Injectable, ViewContainerRef, inject } from '@angular/core';
import {
  NotificationRef,
  NotificationService,
  NotificationSettings,
} from '@progress/kendo-angular-notification';
import { NotificationContainerComponent } from '../components/notification-container/notification-container.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  protected container!: ViewContainerRef;
  private kendoNotificationService = inject(NotificationService);

  public setContainer(container: ViewContainerRef): void {
    this.container = container;
  }

  public showCandidateDeletedSuccessfully(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.CandidateDeletedSuccesfully',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public async showNotAuthorizedNotification() {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'error', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'ERROR.NotAuthorized',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showLoginSuccessful(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.LoginSuccessful',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public show2FACodeSentSuccesfully(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.2FACodeSentSuccessfully',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public show2FACodeSentFailed(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'error', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.2FACodeSentError',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public show2FACodeSentIsInvalid(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'error', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'ERROR.invalid2FACode',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  showLanguageChanged() {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'SUCCESS.languageChanged',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showPasswordResetSuccessful(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.PasswordResetSuccessful',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showPasswordResetFailed(): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'error', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        'notifications.PasswordResetFailure',
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showError(errorName: string): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'error', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(notificationSettings, errorName);
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showWarningNotification(warningMessage: string): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'warning', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        warningMessage,
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }

  public showSuccessNotification(successMessage: string): void {
    const notificationSettings: NotificationSettings = {
      content: NotificationContainerComponent,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: false },
      appendTo: this.container,
      closable: true,
      hideAfter: 5000,
    };
    const notificationRef: NotificationRef =
      this.kendoNotificationService.show(notificationSettings);
    const notificationComponent = notificationRef.content
      ?.instance as NotificationContainerComponent;

    if (notificationComponent) {
      notificationComponent.setUpNotification(
        notificationSettings,
        successMessage,
      );
      notificationComponent.ignore.subscribe(() => notificationRef.hide());
    }
  }
}
